/**
 * @generated SignedSource<<a19ecdbf3568bc1aa25acefcb76c233a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RecipientType = "EMAIL" | "LINK" | "QR_CODE" | "SMS" | "SMS_CODE" | "%future added value";
export type AddRecipientsToListInput = {
  emailAddresses?: ReadonlyArray<string> | null | undefined;
  phoneNumbers?: ReadonlyArray<string> | null | undefined;
  recipientListId: string;
  recipients?: ReadonlyArray<AddRecipientInput> | null | undefined;
};
export type AddRecipientInput = {
  emailAddress?: string | null | undefined;
  phoneNumber?: string | null | undefined;
  preRegisteredMetaQuestionResponses?: ReadonlyArray<QuestionResponseInput> | null | undefined;
  recipientType: RecipientType;
};
export type QuestionResponseInput = {
  comment?: string | null | undefined;
  improve?: boolean | null | undefined;
  noOpinion?: boolean | null | undefined;
  questionId: string;
  selectedResponseOptions?: ReadonlyArray<ResponseOptionResponseInput> | null | undefined;
};
export type ResponseOptionResponseInput = {
  comment?: string | null | undefined;
  value: number;
};
export type AddRecipientsToListMutation$variables = {
  input: AddRecipientsToListInput;
};
export type AddRecipientsToListMutation$data = {
  readonly addRecipientsToList: {
    readonly recipientList: {
      readonly id: string;
      readonly recipientCount: number;
      readonly recipients: ReadonlyArray<{
        readonly emailAddress: string | null | undefined;
        readonly metaQuestionResponses: ReadonlyArray<{
          readonly isPreRegisteredMeta: boolean | null | undefined;
          readonly questionId: string;
          readonly selectedResponseOptions: ReadonlyArray<{
            readonly value: number;
          }>;
        }>;
        readonly phoneNumber: string | null | undefined;
        readonly preRegisteredMetaQuestionResponses: ReadonlyArray<{
          readonly questionId: string;
          readonly selectedResponseOptions: ReadonlyArray<{
            readonly value: number;
          }>;
        }>;
        readonly respondentId: string;
        readonly type: RecipientType;
      }>;
    } | null | undefined;
  };
};
export type AddRecipientsToListMutation = {
  response: AddRecipientsToListMutation$data;
  variables: AddRecipientsToListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": "questionId",
  "args": null,
  "kind": "ScalarField",
  "name": "originalQuestionId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ResponseOptionResponse",
  "kind": "LinkedField",
  "name": "selectedResponseOptions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddRecipientsToListPayload",
    "kind": "LinkedField",
    "name": "addRecipientsToList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipientList",
        "kind": "LinkedField",
        "name": "recipientList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recipientCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Recipient",
            "kind": "LinkedField",
            "name": "recipients",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "respondentId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuestionResponse",
                "kind": "LinkedField",
                "name": "preRegisteredMetaQuestionResponses",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuestionResponse",
                "kind": "LinkedField",
                "name": "metaQuestionResponses",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPreRegisteredMeta",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddRecipientsToListMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddRecipientsToListMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "3cf91ee5ecc06965da4139af50f87e10",
    "id": null,
    "metadata": {},
    "name": "AddRecipientsToListMutation",
    "operationKind": "mutation",
    "text": "mutation AddRecipientsToListMutation(\n  $input: AddRecipientsToListInput!\n) {\n  addRecipientsToList(input: $input) {\n    recipientList {\n      id\n      recipientCount\n      recipients {\n        type\n        emailAddress\n        phoneNumber\n        respondentId\n        preRegisteredMetaQuestionResponses {\n          questionId: originalQuestionId\n          selectedResponseOptions {\n            value\n          }\n        }\n        metaQuestionResponses {\n          questionId: originalQuestionId\n          isPreRegisteredMeta\n          selectedResponseOptions {\n            value\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1fdaff7adb15aa5f2d0bc31cbea9540e";

export default node;
